<template>
  <div class="app-page-header">
    <h2>{{ title }}</h2>
    <p v-if="subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'app-page-header',
  props: ['title', 'subtitle'],
};
</script>

<style lang="scss" scoped>
.app-page-header {
  text-align: center;
  margin-bottom: 32px;

  h2 {
    font-size: 2em;
    font-weight: bold;
  }

  p {
    font-size: 1.2em;
    font-weight: 300;
    color: var(--text-color-light);
  }
}

@media(max-width: 992px) {
  .app-page-header {
    padding: 1em;
  }
}
</style>
